import styled, {css} from 'styled-components';

import {InputFile} from 'components/ui-kit/FileInput';
import {breakpoint, colors} from 'theme';

export const ErrorList = styled.ul`
    margin: 5px 0;
    padding-left: 17px;
`;
export const ErrorItem = styled.li`
    color: ${colors.danger};
    font-size: 14px;
    line-height: 20px;
`;

export const Root = styled.div<{horizontal?: boolean}>`
    display: flex;

    flex-wrap: wrap;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    ${(p) =>
        p.horizontal &&
        css`
            flex-direction: row;
        `}
`;

export const CustomFileInput = styled(InputFile)`
    @media (max-width: ${breakpoint.phone}) {
        min-width: 200px;
        flex: 1;
        width: 100%;
        font-size: 14px;
    }
`;

export const CustomLink = styled.a`
    color: ${colors.brandPrimary};
    font-size: 14px;
    text-decoration: none;
    margin-top: 4px;
    &:hover {
        text-decoration: underline;
    }

    @media (max-width: ${breakpoint.phone}) {
        min-width: 200px;
        flex: 1;
        text-align: center;
    }
`;

export const CustomLinkAction = styled.span`
    color: ${colors.brandPrimary};
    font-size: 14px;
    text-decoration: none;
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }

    @media (max-width: ${breakpoint.phone}) {
        min-width: 200px;
        flex: 1;
        text-align: center;
    }
`;
